<div [ngClass]="{
    'container-xlarge': isXLarge(),
    'container-large': isLarge(),
    'container-medium': isMedium(),
    'container-small': isSmall(),
    'container-xsmall': isXSmall()
  }">
    <div class="content-banner-row">
        <div [ngClass]="{
        'container-content-xlarge': isXLarge(),
        'container-content-large': isLarge(),
        'container-content-medium': isMedium(),
        'container-content-small': isSmall(),
        'container-content-xsmall': isXSmall()
      }">
            <div [ngClass]="{
          'content-xlarge': isXLarge(),
          'content-large': isLarge(),
          'content-medium': isMedium(),
          'content-small': isSmall(),
          'content-xsmall': isXSmall()
        }">
                <h3>{{ customerStorySummary?.readingTime }} read</h3>
                <h1><span class="primary-title">{{ customerStorySummary?.description }}</span></h1>
                <h2>
                    <p><span>Vega-Life, unique lifestyle products for vegetarians and vegans.</span></p>
                    <p><span>They offer sustainable and fashionable products, made without animal suffering or cruelty to compassionate and environmentally conscious people.</span></p>

                </h2>
            </div>
        </div>
        <div [ngClass]="{
        'container-product-banner-image-xlarge': isXLarge(),
        'container-product-banner-image-large': isLarge(),
        'container-product-banner-image-medium': isMedium(),
        'container-product-banner-image-small': isSmall(),
        'container-product-banner-image-xsmall': isXSmall()
      }">
            <img src="{{ customerStorySummary?.storyImageUrl }}" alt="{{ customerStorySummary?.description }}">
        </div>
    </div>

    <div class="content-banner-row">
        <div [ngClass]="{
            'container-stampcard-image-xlarge': isXLarge(),
            'container-stampcard-image-large': isLarge(),
            'container-stampcard-image-medium': isMedium(),
            'container-stampcard-image-small': isSmall(),
            'container-stampcard-image-xsmall': isXSmall()
          }">
            <img src="/assets/img/partners/stories/vega-life-stampcard.png" alt="Vega Life's stamp card">
        </div>
        <div [ngClass]="{
        'content-questions-xlarge': isXLarge(),
        'content-questions-large': isLarge(),
        'content-questions-medium': isMedium(),
        'content-questions-small': isSmall(),
        'content-questions-xsmall': isXSmall()
      }">
            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>How did you come about a loyalty program?</strong></span>
                </div>
                <span><em>We were looking for a way to encourage our customers to return to the store more frequently. Creating a loyalty system ourselves seemed complicated, but then we discovered Planet VG — a great alternative.</em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>Many businesses choose a paper loyalty card. Why have you chosen a digital
                            version?</strong></span>
                </div>
                <span><em>Paper loyalty cards feel a bit outdated nowadays. Since we’re selling fewer and smaller wallets, we assume people are also carrying fewer physical cards. A digital solution just makes more sense.
                    </em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>Why is it important for you to reward your most loyal customers?</strong></span>
                </div>
                <span><em>We want customers to return regularly and keep us top of mind when they think about the products we offer.</em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>While looking for solutions, what were the most important factors for
                            you?</strong></span>
                </div>
                <span><em>Customer loyalty solutions need to be simple to use and appealing to customers. It should be immediately clear that there’s real value in participating.</em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>You chose Planet VG. What attracted you to use our solution?</strong></span>
                </div>
                <span><em>As a vegan business, it’s great to be part of a platform that actively supports vegan companies. That mission really resonated with us.</em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>Can you tell us more about your loyalty program? What do you offer to your customers
                            and why?</strong></span>
                </div>
                <span><em>
                        <p>At the moment, we have savings promotions for vegan cheese and books. Customers can collect stamps to receive a discount or even a free product on their next purchase. It's a nice way to give something back.
                        </p>
                    </em></span>
            </div>

            <div class="container-content-question">
                <div class="content-question">
                    <mat-icon color="primary">eco</mat-icon>
                    <span><strong>Almost there! Would you recommend Planet VG to other businesses you might
                            know?</strong></span>
                </div>
                <span><em>Absolutely. The more businesses that join, the more attractive the program becomes for customers — and the stronger the vegan community becomes.</em></span>
            </div>
        </div>
    </div>
</div>
<app-bottom-menu></app-bottom-menu>